const sanitizeString = (string: string, term: string) => {
    return string
        .split(term)
        .map((item) => item.trim())
        .join("");
};

export default sanitizeString;
